class CountdownTimerCustom {
  constructor(startDate, timezone, element, timer_end_label, endDate) {
    this.timezone = timezone;
    this.element = element;
    this.timer_end_label = timer_end_label;
    this.timer = null;

    this.startDate = new Date(startDate);
    this.today = this.getTimeInTimezone();
    this.endDate = new Date(endDate); // Already in proper format

    this.startCountdown();
  }

  getTimeInTimezone() {
    try {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: this.timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });

      const parts = formatter.formatToParts(new Date());
      const dateParts = Object.fromEntries(parts.map(({ type, value }) => [type, value]));

      return new Date(
        `${dateParts.year}-${dateParts.month}-${dateParts.day}T${dateParts.hour}:${dateParts.minute}:${dateParts.second}`
      );
    } catch (error) {
      console.warn('Failed to parse timezone-adjusted time. Falling back to system time.');
      return new Date();
    }
  }

  calculateTimeRemaining() {
    const now = this.getTimeInTimezone();
    const diff = this.endDate - now;

    if (diff <= 0) {
      clearInterval(this.timer);
      this.updateEndDate();
      return {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
      };
    }

    const days = this.twoPlaces(Math.floor(diff / (1000 * 60 * 60 * 24)));
    const hours = this.twoPlaces(Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
    const minutes = this.twoPlaces(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)));
    const seconds = this.twoPlaces(Math.floor((diff % (1000 * 60)) / 1000));

    return { days, hours, minutes, seconds };
  }

  twoPlaces(number) {
    return number < 10 ? `0${number}` : `${number}`;
  }

  tick() {
    this.timer = setInterval(() => {
      const timeRemaining = this.calculateTimeRemaining();
      this.element.innerHTML = `
        <div class="countdown_count days"><span class="counter">${timeRemaining.days}</span><span class="counter-label">DAY</span></div> <span class="dot-inner">:</span>
        <div class="countdown_count hours"><span class="counter">${timeRemaining.hours}</span><span class="counter-label">HR</span></div> <span class="dot-inner">:</span>
        <div class="countdown_count minutes"><span class="counter">${timeRemaining.minutes}</span><span class="counter-label">MIN</span></div> <span class="dot-inner">:</span>
        <div class="countdown_count seconds"><span class="counter">${timeRemaining.seconds}</span><span class="counter-label">SEC</span></div>
      `;
    }, 1000);
  }

  startCountdown() {
    const now = this.getTimeInTimezone();
    if (now < this.endDate) {
      this.tick();
    } else {
      clearInterval(this.timer);
      this.updateEndDate();
    }
  }

  updateEndDate() {
    const plusTime = 3 * 24 * 60 * 60 * 1000; // +3 days
    const newEndDate = new Date(this.today.getTime() + plusTime);

    this.endDate = newEndDate;
    localStorage.setItem('endDate', newEndDate.toISOString());

    this.startCountdown();
  }
}

// Initialize countdowns
const countdownElements = document.getElementsByClassName('countdown');

function createCountdownTimer(element) {
  const timer_end_label = element.dataset.timer_bar_timer_end;
  const timezone = 'Australia/Sydney';
  const startDate = new Date(Date.UTC(2024, 0, 1, 0, 0)); // Jan 1, 2024, 00:00 UTC
  let endDate = element.dataset.end;

  const today = new Date(); // local system time
  const initialEndDate = new Date(endDate);
  const storedEndDate = localStorage.getItem('endDate');

  if (today > initialEndDate && storedEndDate) {
    console.log('Using stored endDate');
    endDate = storedEndDate;
  }

  new CountdownTimerCustom(startDate, timezone, element, timer_end_label, endDate);
}

// Apply to all elements
Array.from(countdownElements).forEach(createCountdownTimer);
